document.addEventListener('DOMContentLoaded', function () {
  // === CONFIG - adapte si besoin ===
  const BUTTON_SELECTORS = [
    'button.product-form__submit',
    'form.product-form button[type="submit"]',
    '.product-form__submit',
    '.add-to-cart'
  ];
  const PRICE_SELECTORS = [
    '.product-price',
    '.product__price',
    '[data-product-price]',
    '.price__regular',
    '.price'
  ];
  const PRODUCT_QUANTITY_CONTAINER = '.quantity'; // element quantity sur la page produit
  const CART_QUANTITY_CLASS = 'cart-quantity';   // éléments à IGNORER
  // === end config ===

  let isApplying = false;
  let lastDisplayed = null;

  function findFirst(selectors, root = document) {
    for (const s of selectors) {
      const el = root.querySelector(s);
      if (el) return el;
    }
    return null;
  }

  function parsePrice(text) {
    if (!text) return 0;
    let s = String(text).replace(/\u00A0/g, ' ').trim();
    s = s.replace(/[^\d.,-]/g, '');
    if (s.indexOf('.') !== -1 && s.indexOf(',') !== -1) s = s.replace(/\./g, '').replace(',', '.');
    else if (s.indexOf(',') !== -1) s = s.replace(',', '.');
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }

  function formatPrice(val) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(val);
  }

  // Récupère le prix unitaire affiché sur la page produit
  function getUnitPrice() {
    const el = findFirst(PRICE_SELECTORS);
    if (!el) return 0;
    return parsePrice(el.textContent || el.innerText || '');
  }

  // Récupère EXCLUSIVEMENT la quantité du contrôleur produit
  function getProductPageQuantity() {
    // on prend la première .quantity qui n'a pas la classe cart-quantity
    const qtyContainers = Array.from(document.querySelectorAll(PRODUCT_QUANTITY_CONTAINER))
      .filter(el => !el.classList.contains(CART_QUANTITY_CLASS));
    const container = qtyContainers.length ? qtyContainers[0] : null;
    if (!container) return 1;

    // input number standard ?
    const input = container.querySelector('input[type="number"], input.qty, input.quantity__input');
    if (input) {
      const v = parseInt(input.value, 10);
      return (isNaN(v) || v < 1) ? 1 : v;
    }

    // bouton +/- custom : chercher un élément texte affichant le nombre
    const textNode = container.querySelector('span, div, p') || container;
    const match = (textNode.textContent || '').match(/(\d+)/);
    if (match) {
      const v = parseInt(match[1], 10);
      return (isNaN(v) || v < 1) ? 1 : v;
    }

    return 1;
  }

  // Met à jour uniquement le texte affiché dans le bouton (ne touche pas au panier)
  function applyPriceToButton(formatted) {
    document.querySelectorAll(BUTTON_SELECTORS.join(',')).forEach(btn => {
      if (!btn) return;
      // Insérer / mettre à jour un span dédié pour éviter d'abîmer structure & icônes
      let span = btn.querySelector('.price-in-button');
      if (!span) {
        span = document.createElement('span');
        span.className = 'price-in-button';
        span.style.marginLeft = '8px';
        span.style.whiteSpace = 'nowrap';
        btn.appendChild(span);
      }
      const text = ` | ${formatted}`;
      if (span.textContent !== text) {
        span.textContent = text;
        lastDisplayed = text;
      }
    });
  }

  // Calcul + application
  function refreshButtonFromProductQuantity(forceUnitOneAtLoad = false) {
    if (isApplying) return;
    isApplying = true;

    const unit = getUnitPrice();
    if (!unit || unit <= 0) {
      isApplying = false;
      return;
    }

    let qty = getProductPageQuantity();
    // si on force 1 (au chargement), override
    if (forceUnitOneAtLoad) qty = 1;

    const total = unit * qty;
    const formatted = formatPrice(total);
    applyPriceToButton(formatted);

    // small debounce
    setTimeout(() => { isApplying = false; }, 30);
  }

  // Observer léger : si un script externe écrase le bouton, on réapplique la valeur correcte
  function observeButtonsForExternalChanges() {
    document.querySelectorAll(BUTTON_SELECTORS.join(',')).forEach(btn => {
      if (!btn) return;
      const observer = new MutationObserver(muts => {
        if (isApplying) return;
        // si le span dédié a été supprimé ou modifié, on réapplique
        const span = btn.querySelector('.price-in-button');
        if (!span || span.textContent !== lastDisplayed) {
          // reapply after slight delay to let external script finish
          setTimeout(() => refreshButtonFromProductQuantity(false), 25);
        }
      });
      observer.observe(btn, { childList: true, subtree: false, characterData: true });
    });
  }

  // Écoute les changements de la quantité produit uniquement (input/change/click dans le container produit)
  function attachQuantityListeners() {
    // find container (first .quantity that is not cart-quantity)
    const qtyContainers = Array.from(document.querySelectorAll(PRODUCT_QUANTITY_CONTAINER))
      .filter(el => !el.classList.contains(CART_QUANTITY_CLASS));
    const container = qtyContainers.length ? qtyContainers[0] : null;
    if (!container) return;

    // input numeric if present
    const input = container.querySelector('input[type="number"], input.qty, input.quantity__input');
    if (input) {
      input.addEventListener('input', () => refreshButtonFromProductQuantity(false));
      input.addEventListener('change', () => refreshButtonFromProductQuantity(false));
    }

    // clicks in container (for +/- buttons)
    container.addEventListener('click', (e) => {
      // only handle clicks inside product quantity container (we already ensured it's not cart-quantity)
      setTimeout(() => refreshButtonFromProductQuantity(false), 40);
    });

    // observe the product quantity container for DOM changes (some widgets replace nodes)
    try {
      const obs = new MutationObserver(() => { setTimeout(() => refreshButtonFromProductQuantity(false), 30); });
      obs.observe(container, { childList: true, subtree: true, characterData: true });
    } catch (err) { /* noop */ }
  }

  // observe price element to handle variant changes (and then reset to unit*1 briefly)
  function attachPriceObserver() {
    const priceEl = findFirst(PRICE_SELECTORS);
    if (!priceEl) return;
    const obs = new MutationObserver(() => {
      // when price changes due to variant switch, show unit*1 first, then allow quantity interaction
      refreshButtonFromProductQuantity(true);
      setTimeout(() => refreshButtonFromProductQuantity(false), 20);
    });
    obs.observe(priceEl, { childList: true, subtree: true, characterData: true });
  }

  // Boot sequence:
  // 1) Force unit * 1 at load (strict requirement)
  // 2) Attach listeners so subsequent updates come from product page quantity ONLY
  // 3) Observe button to correct external overwrites (light, not aggressive)
  refreshButtonFromProductQuantity(true);
  attachQuantityListeners();
  attachPriceObserver();
  observeButtonsForExternalChanges();

  // small safety re-applies in case scripts load a bit later
  setTimeout(() => refreshButtonFromProductQuantity(true), 120);
  setTimeout(() => refreshButtonFromProductQuantity(false), 400);
});